<template>
  <div v-if="data.report.results.length > 0" class="table-responsive">
    <table class="table table-condensed table-striped standard-report frozen-table">
      <thead>
        <tr class="table-header header text-left">
          <th class="text-left">
            <span class>Item</span>
          </th>
          <th class="text-left">
            <span class>Category</span>
          </th>
          <th class="text-center">
            <span class>Sold</span>
          </th>
          <th class="text-center">
            <span class>Sold LW</span>
          </th>
          <th class="text-right">
            <span class>Sales</span>
          </th>
          <th class="text-right">
            <span class>Avg Price</span>
          </th>
          <th class="text-right">
            <span class>Cost</span>
          </th>
          <th class="text-right">
            <span class>Gross Profit</span>
          </th>
          <th class="text-center">
            <span class>LW {{ data.report.results[0].lastweek_day }}</span>
          </th>
          <th class="text-center">
            <span class>Recent Avg</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="border-right"
          v-for="v in data.report.results"
          :key="v.id"
          v-show="data.report.results.length > 0"
        >
          <td class="text-left">{{ v.itemNAME }}</td>
          <td class="text-left">{{ v.category }}</td>
          <td class="text-center">{{ v.numSold }}</td>
          <td class="text-center">{{ v.numSoldLW }}</td>
          <td class="text-right">{{ v.sales | currency }}</td>
          <td class="text-right">{{ v.avgPrice | currency }}</td>
          <td class="text-right">{{ v.cost | currency }}</td>
          <td class="text-right">{{ v.grossProfit | currency }}</td>
          <td class="text-center">{{ v.LWtomorrow }}</td>
          <td class="text-center">{{ v.recentAVG }}</td>
        </tr>
        <tr class="border-right" v-show="!data.report.results.length > 0">
          <td class="text-center" colspan="10">NO DATA AVAILABLE</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import UserService from '@/services/UserService'
import DailyJournalReportService from '@/services/DailyJournalReportService'
import DailyReportTab from './dailyReportTab'

export default {
  extends: DailyReportTab,
  components: {
  },
  data () {
    return {
      data: {
        loading: true,
        report: {
          results: []
        }
      },
      loadTimeout: null
    }
  },
  computed: {
    grossView: function () {
      return UserService.getConfigOption('gross_sales_view').value === 'yes'
    },
    checkGuestStats: function () {
      return UserService.getConfigOption('avg_check_guest_stats').value === 'yes'
    }
  },
  methods: {
    loadData: function () {
      if (this.isActive > 0 && this.loadTimeout === null) {
        this.loadTimeout = setTimeout(() => {
          this.$updateloading(1)
          this.data.loading = true
          DailyJournalReportService.getItemSummary(this.locationId, this.dailyDate)
            .then(res => {
              this.$updateloading(-1)
              this.data.loading = false
              this.data.report = res
              this.loadTimeout = null
            })
        }, 100)
      }
    }
  }
}
</script>
